import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { fetchStudentProfile, updateStudentProfile } from "../../api/studentApi"; // ✅ Import correct API functions
import "./EditStudent.css";

const EditStudent = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    enrollmentNumber: "",
    profileImageUrl: "",
    photo: null, 
  });

  const [photoPreview, setPhotoPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // ✅ Fetch Student Profile on Component Mount
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await fetchStudentProfile(); // ✅ Correct function
        console.log("✅ Fetched Student Profile:", data);

        if (!data) {
          console.error("❌ No Student Data Found!");
          return;
        }

        setFormData({
          profileImageUrl: data.profileImageUrl || "",
          firstName: data.firstName || "",
          lastName: data.lastName || "",
          enrollmentNumber: data.enrollmentNumber || "",
        });
      } catch (error) {
        console.error("❌ Error Fetching Student Profile", error);
        alert("Error fetching profile. Please try logging in again.");
        navigate("/login");
      }
    };

    fetchProfile();
  }, [navigate]);

  // ✅ Handle File Upload
  const handleChange = (e) => {
    const { name, files } = e.target;
    if (name === "photo" && files.length > 0) {
      const file = files[0];

      if (file.size > 5 * 1024 * 1024) {
        alert("⚠️ File size exceeds 5 MB. Please upload a smaller file.");
        return;
      }

      setFormData((prevData) => ({
        ...prevData,
        photo: file,
      }));

      setPhotoPreview(URL.createObjectURL(file)); 
    }
  };

  // ✅ Handle Profile Update
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await updateStudentProfile(formData); // ✅ Correct function
      console.log("✅ Student Profile Updated:", response.data);
      alert("✅ Profile updated successfully!");

      navigate("/dashboard"); // Redirect after update
    } catch (error) {
      console.error("❌ Error updating profile:", error);
      setErrorMessage("Error updating profile. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="edit-students">
      <div className="form-container">
        <h1>Edit Student Profile</h1>

        {errorMessage && <p className="error-text">{errorMessage}</p>}

        <form onSubmit={handleSubmit}>
          {/* Profile Photo Upload */}
          <div className="form-group">
            <div className="photo-placeholder">
              {photoPreview ? (
                <img src={photoPreview} alt="Profile Preview" />
              ) : formData.profileImageUrl ? (
                <img src={formData.profileImageUrl} alt="Current Profile" />
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="gray" width="50%" height="50%">
                  <circle cx="12" cy="8" r="4" />
                  <path d="M2 20c0-5.33 4.33-8 10-8s10 2.67 10 8H2z" />
                </svg>
              )}
            </div>
            <div className="photo-options">
              <label htmlFor="photo-upload" className="upload-btn">
                Upload New Photo
              </label>
              <input type="file" id="photo-upload" name="photo" accept="image/*" onChange={handleChange} />
            </div>
          </div>

          {/* Non-editable Fields */}
          <div className="form-group">
            <label>First Name:</label>
            <input type="text" value={formData.firstName} disabled />
          </div>

          <div className="form-group">
            <label>Last Name:</label>
            <input type="text" value={formData.lastName} disabled />
          </div>

          <div className="form-group">
            <label>Enrollment Number:</label>
            <input type="text" value={formData.enrollmentNumber} disabled />
          </div>

          {/* Submit Button */}
          <div className="button-group">
            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? "Updating..." : "Update Profile"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditStudent;